// Small helper to obtain the API base URL reliably in the browser
// Prefers env, falls back to bundled settings.json

export function getServerURL() {
  // In React, environment variables are embedded at build time
  // Check for the environment variable directly
  const envUrl = process.env.REACT_APP_SERVER_URL;
  
  // Ensure we have a valid string and trim it
  if (envUrl && typeof envUrl === 'string') {
    const trimmedEnv = envUrl.trim();
    if (trimmedEnv) {
      return trimmedEnv;
    }
  }
  
  // Fallback to settings.json if available
  try {
    // eslint-disable-next-line global-require
    const settings = require('../settings.json');
    if (settings && typeof settings.serverURL === 'string' && settings.serverURL.trim()) {
      return settings.serverURL.trim();
    }
  } catch (_e) {}
  // Final fallback to live API
  return 'https://api.bysnaps.ai';
}


